<template>
  <div>

    <!-- <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success baseHeader">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic" type="gradient-red" sub-title="350,897" icon="ni ni-active-40" class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic" type="gradient-orange" sub-title="2,356" icon="ni ni-chart-pie-35"
            class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Sales" type="gradient-green" sub-title="924" icon="ni ni-money-coins" class="mb-4">

            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Performance" type="gradient-info" sub-title="49,65%" icon="ni ni-chart-bar-32"
            class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header> -->

    <template>
  <div>
    <base-header class="pb-4 pt-5 pt-md-8 bg-gradient-primary baseHeader header-enhanced">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            title="Total Users"
            type="gradient-red"
            :sub-title="totalUsers ? totalUsers.toLocaleString() : 'Loading...'"
            icon="ni ni-single-02"
            class="mb-4 stats-card-hover"
          >
            <template slot="footer">
              <span class="text-success mr-2">✓ Updated</span>
              <span class="text-nowrap">{{ lastUpdated }}</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Top Streak Users"
            type="gradient-info"
            icon="ni ni-trophy"
            class="mb-4 stats-card-hover"
          >
            <h5 class="card-title text-uppercase text-muted mb-3">Top Performers</h5>
            <div v-if="topStreakUsers.length" class="streak-list">
              <div
                v-for="(user, index) in topStreakUsers.slice(0, 3)"
                :key="index"
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <div class="d-flex align-items-center">
                  <span class="badge badge-primary mr-2">{{ index + 1 }}</span>
                  <span class="font-weight-600">{{ user.nickname }}</span>
                </div>
                <span class="badge badge-success">
                  {{ user.current_streak }} days
                </span>
              </div>
            </div>
            <div v-else>
              <p class="mb-0 text-muted">No streak data available.</p>
            </div>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Active Sessions"
            type="gradient-orange"
            sub-title="247"
            icon="ni ni-watch-time"
            class="mb-4 stats-card-hover"
          >
            <template slot="footer">
              <span class="text-warning mr-2">↗ 12.5%</span>
              <span class="text-nowrap">vs last week</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="System Health"
            type="gradient-green"
            sub-title="98.5%"
            icon="ni ni-check-bold"
            class="mb-4 stats-card-hover"
          >
            <template slot="footer">
              <span class="text-success mr-2">● Online</span>
              <span class="text-nowrap">All systems operational</span>
            </template>
          </stats-card>
        </b-col>
        <!-- <b-col xl="3" md="6">
          <stats-card title="Sales" type="gradient-green" sub-title="924" icon="ni ni-money-coins" class="mb-4">
            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col> -->
        <!-- <b-col xl="3" md="6">
          <stats-card title="Performance" type="gradient-info" sub-title="49,65%" icon="ni ni-chart-bar-32"
            class="mb-4">
            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col> -->
      </b-row>
    </base-header>
  </div>
</template>

    <!--Charts-->
    <b-container fluid class="mt-6">
      <b-row>
        <b-col xl="8" class="mb-5 mb-xl-0">
          <card type="default" header-classes="bg-gradient-primary border-0 shadow" class="chart-card">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-white text-uppercase ls-1 mb-1">
                  <i class="ni ni-chart-bar-32 mr-2"></i>Analytics Overview
                </h6>
                <h5 class="h3 text-white mb-0">User Engagement</h5>
              </b-col>
              <b-col>
                <b-nav class="nav-pills justify-content-end">
                  <b-nav-item class="mr-2 mr-md-0" :active="bigLineChart.activeIndex === 0"
                    link-classes="py-2 px-3 bg-white text-primary"
                    @click.prevent="initBigChart(0)">
                    <span class="d-none d-md-block">Month</span>
                    <span class="d-md-none">M</span>
                  </b-nav-item>
                  <b-nav-item link-classes="py-2 px-3 bg-white text-primary" :active="bigLineChart.activeIndex === 1"
                    @click.prevent="initBigChart(1)">
                    <span class="d-none d-md-block">Week</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>
                </b-nav>
              </b-col>
            </b-row>
            <div class="chart-container">
              <line-chart :height="350" ref="bigChart" :chart-data="bigLineChart.chartData"
                :extra-options="bigLineChart.extraOptions">
              </line-chart>
            </div>
          </card>
        </b-col>

        <b-col xl="4" class="mb-5 mb-xl-0">
          <card header-classes="bg-gradient-success border-0 shadow" class="chart-card">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-white text-uppercase ls-1 mb-1">
                  <i class="ni ni-chart-pie-35 mr-2"></i>Performance
                </h6>
                <h5 class="h3 text-white mb-0">Activity Metrics</h5>
              </b-col>
            </b-row>

            <div class="chart-container">
              <bar-chart :height="350" ref="barChart" :chart-data="redBarChart.chartData"
                :extra-options="redBarChart.extraOptions">
              </bar-chart>
            </div>
          </card>
        </b-col>
      </b-row>
      <!-- End charts-->

      <!--Tables-->
      <b-row class="mt-5">
        <b-col xl="8" class="mb-5 mb-xl-0">
          <page-visits-table></page-visits-table>
        </b-col>
        <b-col xl="4" class="mb-5 mb-xl-0">
          <social-traffic-table></social-traffic-table>
        </b-col>
      </b-row>
      <!--End tables-->

      <!-- Quick Actions & Recent Activity -->
      <b-row class="mt-5">
        <b-col xl="6" class="mb-5 mb-xl-0">
          <card header-classes="bg-gradient-danger border-0 shadow" class="activity-card">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-white text-uppercase ls-1 mb-1">
                  <i class="ni ni-bell-55 mr-2"></i>Quick Actions
                </h6>
                <h5 class="h3 text-white mb-0">Administrative Tasks</h5>
              </b-col>
            </b-row>

            <div class="action-buttons">
              <b-row>
                <b-col md="6" class="mb-3">
                  <b-button block variant="light" class="action-btn shadow-sm">
                    <i class="ni ni-single-02 mr-2"></i>
                    <span class="d-block font-weight-600">Manage Users</span>
                    <small class="text-muted">Add/Edit user accounts</small>
                  </b-button>
                </b-col>
                <b-col md="6" class="mb-3">
                  <b-button block variant="light" class="action-btn shadow-sm">
                    <i class="ni ni-music-note mr-2"></i>
                    <span class="d-block font-weight-600">Upload Music</span>
                    <small class="text-muted">Add new music content</small>
                  </b-button>
                </b-col>
                <b-col md="6" class="mb-3">
                  <b-button block variant="light" class="action-btn shadow-sm">
                    <i class="ni ni-button-play mr-2"></i>
                    <span class="d-block font-weight-600">Upload Videos</span>
                    <small class="text-muted">Add video content</small>
                  </b-button>
                </b-col>
                <b-col md="6" class="mb-3">
                  <b-button block variant="light" class="action-btn shadow-sm">
                    <i class="ni ni-notification-70 mr-2"></i>
                    <span class="d-block font-weight-600">Send Announcement</span>
                    <small class="text-muted">Broadcast messages</small>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </card>
        </b-col>

        <b-col xl="6" class="mb-5 mb-xl-0">
          <card header-classes="bg-gradient-purple border-0 shadow" class="activity-card">
            <b-row align-v="center" slot="header">
              <b-col>
                <h6 class="text-white text-uppercase ls-1 mb-1">
                  <i class="ni ni-time-alarm mr-2"></i>Recent Activity
                </h6>
                <h5 class="h3 text-white mb-0">System Events</h5>
              </b-col>
            </b-row>

            <div class="activity-feed">
              <div class="activity-item" v-for="(activity, index) in recentActivities" :key="index">
                <div class="d-flex align-items-start">
                  <div class="activity-icon mr-3" :class="activity.iconClass">
                    <i :class="activity.icon"></i>
                  </div>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 class="mb-0 font-weight-600">{{ activity.title }}</h6>
                        <p class="mb-0 text-sm text-muted">{{ activity.description }}</p>
                      </div>
                      <small class="text-muted">{{ activity.time }}</small>
                    </div>
                  </div>
                </div>
                <hr v-if="index < recentActivities.length - 1" class="my-3">
              </div>
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>
<script>
// Charts
import * as chartConfigs from '@/components/Charts/config';
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';

// Components
import BaseProgress from '@/components/BaseProgress';
import Card from '../Cards/Card';
import StatsCard from '@/components/Cards/StatsCard';

// Tables
import SocialTrafficTable from './Dashboard/SocialTrafficTable';
import PageVisitsTable from './Dashboard/PageVisitsTable';
import baseHeader from '../BaseHeader';
import axios from 'axios';

export default {
  components: {
    Card,
    baseHeader,
    LineChart,
    BarChart,
    // BaseProgress,
    StatsCard,
    PageVisitsTable,
    SocialTrafficTable
  },
  data() {
    return {
      totalUsers: null, // Métrica de usuarios totales
      lastUpdated: '',
      topStreakUsers: [],
      recentActivities: [
        {
          title: 'New user registered',
          description: 'John Doe joined the platform',
          time: '2 min ago',
          icon: 'ni ni-single-02',
          iconClass: 'success-bg'
        },
        {
          title: 'Music album uploaded',
          description: 'New album "Summer Vibes" added',
          time: '15 min ago',
          icon: 'ni ni-music-note',
          iconClass: 'primary-bg'
        },
        {
          title: 'Video content moderated',
          description: 'Content review completed',
          time: '1 hour ago',
          icon: 'ni ni-check-bold',
          iconClass: 'info-bg'
        },
        {
          title: 'System backup completed',
          description: 'Daily backup successful',
          time: '3 hours ago',
          icon: 'ni ni-folder-17',
          iconClass: 'warning-bg'
        }
      ],
      bigLineChart: {
        allData: [
          [0, 20, 10, 30, 15, 40, 20, 60, 60],
          [0, 20, 5, 25, 10, 30, 15, 40, 40]
        ],
        activeIndex: 0,
        chartData: {
          datasets: [
            {
              label: 'Active Users',
              data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
              borderColor: '#5e72e4',
              backgroundColor: 'rgba(94, 114, 228, 0.1)',
              pointBackgroundColor: '#5e72e4',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#5e72e4',
              borderWidth: 3,
              pointRadius: 5,
              pointHoverRadius: 7,
              fill: true,
            }
          ],
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
        },
        extraOptions: {
          ...chartConfigs.blueChartOptions,
          tooltips: {
            backgroundColor: '#fff',
            titleFontColor: '#333',
            bodyFontColor: '#666',
            borderColor: '#5e72e4',
            borderWidth: 1,
          },
          scales: {
            yAxes: [{
              gridLines: {
                color: 'rgba(0, 0, 0, 0.1)',
                zeroLineColor: 'rgba(0, 0, 0, 0.1)',
              },
              ticks: {
                callback: function(value) {
                  return value + 'k';
                }
              }
            }],
            xAxes: [{
              gridLines: {
                color: 'rgba(0, 0, 0, 0.1)',
              }
            }]
          }
        },
      },
      redBarChart: {
        chartData: {
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [{
            label: 'Daily Activity',
            data: [25, 20, 30, 22, 17, 29, 35],
            backgroundColor: [
              'rgba(255, 99, 132, 0.8)',
              'rgba(54, 162, 235, 0.8)',
              'rgba(255, 205, 86, 0.8)',
              'rgba(75, 192, 192, 0.8)',
              'rgba(153, 102, 255, 0.8)',
              'rgba(255, 159, 64, 0.8)',
              'rgba(94, 114, 228, 0.8)'
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 205, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)',
              'rgba(94, 114, 228, 1)'
            ],
            borderWidth: 2
          }]
        },
        extraOptions: {
          ...chartConfigs.blueChartOptions,
          tooltips: {
            backgroundColor: '#fff',
            titleFontColor: '#333',
            bodyFontColor: '#666',
            borderColor: '#5e72e4',
            borderWidth: 1,
          },
          scales: {
            yAxes: [{
              gridLines: {
                color: 'rgba(0, 0, 0, 0.1)',
                zeroLineColor: 'rgba(0, 0, 0, 0.1)',
              },
              ticks: {
                beginAtZero: true
              }
            }],
            xAxes: [{
              gridLines: {
                color: 'rgba(0, 0, 0, 0.1)',
              }
            }]
          }
        }
      }
    };
  },
  methods: {
    async fetchTopStreakUsers() {
      try {
        const apiUrl = `${process.env.VUE_APP_ROOT_API}api/top-streak-users`;
        const response = await axios.get(apiUrl, {
          headers: {
            'Authorization' : `Bearer ${this.$store.state.auth.accessToken}`, // Token de autenticación
          },
        });

        if (response.status === 200 && response.data.success) {
          this.topStreakUsers = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching top streak users:', error);
      }
    },
    async fetchTotalUsers() {
      try {
        const apiUrl = `${process.env.VUE_APP_ROOT_API}api/users`;
        const response = await axios.get(apiUrl, {
          params: {
            page: 1, // Para obtener la métrica total
            perPage: 1, // No necesitamos todos los datos
          },
          headers: {
            'Authorization' : `Bearer ${this.$store.state.auth.accessToken}`, // Token de autenticación
          },
        });

        if (response.status === 200 && response.data.total) {
          this.totalUsers = response.data.total;
          this.lastUpdated = new Date().toLocaleString(); // Fecha y hora actual
        }
      } catch (error) {
        console.error('Error fetching total users:', error);
      }
    },
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: 'Performance',
            data: this.bigLineChart.allData[index]
          }
        ],
        labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    }
  },
  mounted() {
    this.initBigChart(0);
    this.fetchTotalUsers();
    this.fetchTopStreakUsers();
  }
};
</script>
<style>
/* Color Scheme Variables */
:root {
  --primary-gradient: linear-gradient(135deg, #5e72e4 0%, #4c63d2 100%);
  --success-gradient: linear-gradient(135deg, #2dce89 0%, #1aa260 100%);
  --info-gradient: linear-gradient(135deg, #11cdef 0%, #0da8c7 100%);
  --warning-gradient: linear-gradient(135deg, #fb6340 0%, #f56036 100%);
  --danger-gradient: linear-gradient(135deg, #f5365c 0%, #e31c52 100%);
  --purple-gradient: linear-gradient(135deg, #8965e0 0%, #6f42c1 100%);
  --orange-gradient: linear-gradient(135deg, #ff8a00 0%, #e67e22 100%);
  --green-gradient: linear-gradient(135deg, #2dce89 0%, #1aa260 100%);

  --shadow-light: 0 2px 10px rgba(0, 0, 0, 0.1);
  --shadow-medium: 0 10px 25px rgba(0, 0, 0, 0.15);
  --shadow-heavy: 0 15px 35px rgba(0, 0, 0, 0.2);

  --border-radius: 12px;
  --transition: all 0.3s ease;
}

/* .el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
} */
.baseHeader {
  margin-top: -80px;
  position: relative;
  overflow: hidden;
}

.baseHeader::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(94, 114, 228, 0.9) 0%, rgba(76, 99, 210, 0.9) 100%);
  z-index: 1;
}

.baseHeader::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%);
  z-index: 1;
}

.header-enhanced .card {
  position: relative;
  z-index: 2;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
}

.header-enhanced .text-white {
  color: #fff !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.header-enhanced .card-body {
  position: relative;
  z-index: 2;
}

/* Enhanced Stats Cards */
.stats-card-hover {
  transition: var(--transition);
  cursor: pointer;
  border-radius: var(--border-radius) !important;
}

.stats-card-hover:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-medium) !important;
}

.stats-card-hover .card-body {
  transition: var(--transition);
}

.stats-card-hover:hover .card-body {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
}

.streak-list {
  max-height: 120px;
  overflow-y: auto;
}

.streak-list::-webkit-scrollbar {
  width: 4px;
}

.streak-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.streak-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.streak-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Card animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.stats-card-hover {
  animation: fadeInUp 0.6s ease-out;
}

.chart-card:nth-child(1) {
  animation: slideInLeft 0.8s ease-out;
}

.chart-card:nth-child(2) {
  animation: slideInRight 0.8s ease-out;
}

.table-card:nth-child(1) {
  animation: slideInLeft 0.8s ease-out 0.2s both;
}

.table-card:nth-child(2) {
  animation: slideInRight 0.8s ease-out 0.4s both;
}

.activity-card:nth-child(1) {
  animation: slideInLeft 0.8s ease-out 0.6s both;
}

.activity-card:nth-child(2) {
  animation: slideInRight 0.8s ease-out 0.8s both;
}

/* Loading animation for data */
@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

.loading-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: shimmer 1.5s infinite;
}

/* Enhanced Chart Cards */
.chart-card {
  transition: var(--transition);
  border-radius: var(--border-radius) !important;
  overflow: hidden;
}

.chart-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-heavy) !important;
}

.chart-container {
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0 0 var(--border-radius) var(--border-radius);
}

/* Table Cards */
.table-card {
  border-radius: var(--border-radius) !important;
  overflow: hidden;
  transition: var(--transition);
}

.table-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-heavy) !important;
}

/* Activity Cards */
.activity-card {
  border-radius: var(--border-radius) !important;
  overflow: hidden;
  transition: var(--transition);
}

.activity-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-heavy) !important;
}

.action-buttons {
  padding: 20px;
}

.action-btn {
  border: none !important;
  transition: all 0.3s ease;
  text-align: left;
  height: auto;
  padding: 15px;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
  background-color: #fff !important;
}

.activity-feed {
  padding: 20px;
  max-height: 300px;
  overflow-y: auto;
}

.activity-item {
  margin-bottom: 15px;
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.success-bg { background: var(--success-gradient); }
.primary-bg { background: var(--primary-gradient); }
.info-bg { background: var(--info-gradient); }
.warning-bg { background: var(--warning-gradient); }
.purple-bg { background: var(--purple-gradient); }

/* Custom scrollbar for activity feed */
.activity-feed::-webkit-scrollbar {
  width: 4px;
}

.activity-feed::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.activity-feed::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.activity-feed::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .stats-card-hover:hover {
    transform: none;
  }

  .chart-card:hover {
    transform: none;
  }

  .activity-card:hover {
    transform: none;
  }

  .chart-container {
    padding: 15px;
  }

  .action-buttons {
    padding: 15px;
  }

  .activity-feed {
    padding: 15px;
  }

  .action-btn:hover {
    transform: none;
  }

  .activity-icon {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }
}
</style>
